export function log(label, data) {
    if (data !== undefined) {
        console.log(`${label}:`, data);
        
    } else {
        console.log(label);
    }
}